import { useState } from 'react';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router';
import { DATE_FORMAT } from '../../const/system';



const setReleasedToCondition = (type, prevReleasedTo, responseDataReleasedTo) => {
  let isChangedReleasedTo;

  switch (type) {
    case 'default':
      isChangedReleasedTo = !dayjs(responseDataReleasedTo).isSame(prevReleasedTo);
      break;
    case 'feature':
      isChangedReleasedTo = !dayjs(responseDataReleasedTo).isSame(prevReleasedTo)
        && prevReleasedTo !== null && responseDataReleasedTo !== null;
      break;
    default:
      isChangedReleasedTo = !dayjs(responseDataReleasedTo).isSame(prevReleasedTo);
  }

  return isChangedReleasedTo;
};

const useNavigateToPrioritiesAfterUpdate = () => {
  const navigate = useNavigate();
  const [ prevReleasedAt, setPrevReleasedAt ] = useState(null);
  const [ prevReleasedTo, setPrevReleasedTo ] = useState(null);
  const [ prevIsPublished, setPrevIsPublished ] = useState(null);

  const setPrevValues = (entity) => {
    setPrevIsPublished(entity?.is_published);
    setPrevReleasedAt(entity?.released_at);
    setPrevReleasedTo(entity?.released_to);
  };

  const navigateToPrioritiesAfterUpdate = (responseData, prioritiesUrl, alternateNavigateUrl, pageType = 'default') => {
    const isChangedReleasedAt = !dayjs(responseData?.released_at).isSame(prevReleasedAt);
    const isChangedReleasedTo = setReleasedToCondition(pageType, prevReleasedTo, responseData?.released_to);
    const isPublished = prevIsPublished === false && responseData?.is_published === true;
    const isRepublished = dayjs(responseData?.updated_at).isSame(dayjs(responseData?.published_at)) && responseData?.is_published === true;
    const redirectToPrioritiesPage = isPublished || (isRepublished && (isChangedReleasedAt || isChangedReleasedTo));

    if (redirectToPrioritiesPage) {
      const dateToNavigate = dayjs(responseData?.released_at).format(DATE_FORMAT);
      const params = new URLSearchParams();

      params.set('search', `date:${dateToNavigate}`);
      navigate(`${prioritiesUrl}?${params.toString()}`);
    } else if (isRepublished) {
      navigate(alternateNavigateUrl);
    }
  };

  return { navigateToPrioritiesAfterUpdate, setPrevValues };
};

export default useNavigateToPrioritiesAfterUpdate;
